import type { ReactNode } from 'react';

import { useReportPreviewModal } from '@mint-lib/ai-chat';
import { cn } from '@mint-lib/tw-utils';

type Props = {
  chatList: ReactNode;
  header: ReactNode;
  chat: ReactNode;
  reportPreview: ReactNode;
};

const AgenticAiModalCompact = ({
  header,
  chatList,
  chat,
  reportPreview,
}: Props) => {
  const { open: reportPreviewOpen } = useReportPreviewModal();

  return (
    <div className="m-px rounded-lg bg-gradient-to-bl from-ai-lightCyan to-ai-lightGreen">
      <div className="flex h-screen max-h-186 max-w-full flex-col justify-start gap-4 overflow-x-visible rounded-[6px] bg-ui-primary p-4">
        <div className="flex h-full w-full flex-row gap-4 bg-ui-primary">
          {chatList}
          <div
            className={cn('flex h-full w-full min-w-0 flex-col', {
              hidden: !!reportPreview && reportPreviewOpen,
            })}
          >
            {header}
            {chat}
          </div>
          {reportPreview}
        </div>
      </div>
    </div>
  );
};

export default AgenticAiModalCompact;
